import React from "react";

const MapMarkerIcon = ({ fill, ...restProps }) => {
  return (
    <svg
      width="178"
      height="177"
      viewBox="0 0 178 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <circle
        opacity="0.3"
        cx="89.0013"
        cy="88.6312"
        r="87.642"
        fill="#FEF7C3"
        stroke="#B2A186"
      />
      <circle
        opacity="0.6"
        cx="89.0001"
        cy="88.631"
        r="41.3517"
        fill="#FEF7C3"
        stroke="#B2A186"
      />
      <circle
        cx="89.0021"
        cy="88.631"
        r="11.4474"
        fill="#FEF7C3"
        stroke="#3B3020"
      />
    </svg>
  );
};

export default MapMarkerIcon;
